import DateColumn from './components/DateColumn';
import creatorColumn from './components/creatorColumn';
import IndexColumn from './components/IndexColumn';
import InstitutionColumn from './components/InstitutionColumn';
import StatusColumn from './components/StatusColumn';
import genderColumn from './components/GenderColumn';

interface SubComponents {
  Index: typeof IndexColumn;
  Creator: typeof creatorColumn;
  Date: typeof DateColumn;
  Institution: typeof InstitutionColumn;
  Status: typeof StatusColumn;
  Gender: typeof genderColumn;
}

const ColumnTemplate: React.FC<any> & SubComponents = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className="my-3 flex flex-wrap gap-1 text-[12px]">{children}</div>;
};

ColumnTemplate.Index = IndexColumn;
ColumnTemplate.Creator = creatorColumn;
ColumnTemplate.Date = DateColumn;
ColumnTemplate.Institution = InstitutionColumn;
ColumnTemplate.Status = StatusColumn;
ColumnTemplate.Gender = genderColumn;

ColumnTemplate.displayName = 'ColumnTemplate';
export default ColumnTemplate;
